// extracted by mini-css-extract-plugin
module.exports = {"accountsPage":"accountsPage__wvUam","errorAlert":"errorAlert__f3VLl","institutions":"institutions__rwChf","noDataContent":"noDataContent__MIYn+","icon":"icon__NfmCg"};